// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"349039a9","455":"f6b7dbd5","977":"2f278ff5"}[chunkId] + ".chunk.js";
};